import appSettings from 'wanderu-config';
import Logger from 'wanderu-logger';
import { SnowplowService } from 'wanderu-service-analytics';
import WapiService from 'wanderu-service-wapi';
import { makeQueryString } from 'wanderu-utils';

import {
    actions as carrierActions,
} from '../../appstate';
import { FILTER_FIELDS } from '../../constants';
import {
    namespace,
    actions,
    reducer,
    selectors,
} from './base';

const logger = Logger.getLogger('wanderu-ducks-carriers:fetchAllCarriers');

async function getMultipleCarrierData(carrierIds) {
    const query = {
        fields: FILTER_FIELDS.join(','),
        carrier_id: carrierIds && carrierIds.join(','),
    };

    try {
        const response = await WapiService.get(`carriers.json${makeQueryString(query)}`);

        return response.result;
    } catch (ex) {
        logger.info('getMultipleCarrierData', 'error while fetching updated carrier data', ex.message);
    }
}

function fetch() {
    return async (dispatch) => {
        dispatch(actions.startWork());

        let error;

        try {
            const carrierData = await getMultipleCarrierData();
            if (!carrierData) {
                throw new Error('no carrier data found');
            }

            dispatch(carrierActions.setAllCarrierData(
                carrierData.reduce((allCarriers, carrier) => {
                    return {
                        ...allCarriers,
                        [carrier.carrier_id]: carrier,
                    };
                }, {}),
            ));
        } catch (ex) {
            const domainUserInfo = appSettings.env.isClient
                ? SnowplowService.getDomainUserInfo()
                : {};

            logger.warn('fetch', ex, {
                snowplowIds: {
                    networkUserId: SnowplowService.getNetworkUserId(),
                    ...domainUserInfo,
                },
            });

            error = {
                message: ex.message,
            };
        } finally {
            dispatch(actions.endWork(undefined, undefined, error));
        }
    };
}

const fetchAllCarriersAction = {
    fetch,
    ...selectors,
};

export {
    fetchAllCarriersAction,
};

export default {
    [namespace]: reducer,
};
